import React, { useEffect, useState } from 'react';
import { ButtonBase, Dialog, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { getAttachmentUrl } from './chatApi';

const maxImageSide = 1600;
const imageQuality = 0.8;
const thumbnailSize = 96;

const thumbnailStyle = {
  width: thumbnailSize,
  height: thumbnailSize,
  objectFit: 'cover',
  borderRadius: 4,
  backgroundColor: '#e0e0e0',
};

const Thumbnail = ({ url, onOpen }) => (
  <ButtonBase onClick={() => onOpen(url)} style={{ borderRadius: 4 }}>
    <img src={url} alt="снимка" style={thumbnailStyle} />
  </ButtonBase>
);

// Снимките от таблета са по няколко MB — смаляват се преди качване (по-дългата страна до 1600 px, JPEG).
const compressImage = file =>
  new Promise((resolve, reject) => {
    const source = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      const scale = Math.min(1, maxImageSide / Math.max(image.width, image.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(image.width * scale);
      canvas.height = Math.round(image.height * scale);
      canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(source);
      canvas.toBlob(
        blob => (blob ? resolve(blob) : reject(new Error('Снимката не може да се обработи.'))),
        'image/jpeg',
        imageQuality
      );
    };
    image.onerror = () => {
      URL.revokeObjectURL(source);
      reject(new Error('Файлът не е снимка.'));
    };
    image.src = source;
  });

const ServerImage = ({ attachmentId, onOpen }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getAttachmentUrl(attachmentId)
      .then(x => !cancelled && setUrl(x))
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
    };
  }, [attachmentId]);

  if (failed)
    return (
      <Typography style={{ ...thumbnailStyle, fontSize: '0.75em', padding: 4 }}>
        Снимката не е налична
      </Typography>
    );
  return url ? <Thumbnail url={url} onOpen={onOpen} /> : <div style={thumbnailStyle} />;
};

// Снимките на съобщение: от сървъра (по id) или още неизпратените (локален адрес); клик — на цял екран.
const MessageAttachments = ({ attachments = [], previews = [] }) => {
  const [openUrl, setOpenUrl] = useState(null);
  if (!attachments.length && !previews.length) return null;

  return (
    <>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, margin: '4px 0' }}>
        {attachments.map(x => (
          <ServerImage key={x.id} attachmentId={x.id} onOpen={setOpenUrl} />
        ))}
        {previews.map(x => (
          <Thumbnail key={x} url={x} onOpen={setOpenUrl} />
        ))}
      </div>
      <Dialog open={!!openUrl} onClose={() => setOpenUrl(null)} fullScreen>
        <IconButton
          onClick={() => setOpenUrl(null)}
          style={{ position: 'absolute', top: 8, right: 8, backgroundColor: '#ffffffcc' }}
        >
          <Close />
        </IconButton>
        {openUrl && (
          <img
            src={openUrl}
            alt="снимка"
            style={{ width: '100%', height: '100%', objectFit: 'contain', backgroundColor: '#000' }}
          />
        )}
      </Dialog>
    </>
  );
};

// Избраните снимки преди изпращане — с бутон за махане.
const DraftAttachments = ({ drafts, onRemove }) =>
  drafts.length ? (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, padding: '4px 6px' }}>
      {drafts.map(x => (
        <div key={x.previewUrl} style={{ position: 'relative' }}>
          <img src={x.previewUrl} alt="снимка" style={thumbnailStyle} />
          <IconButton
            size="small"
            onClick={() => onRemove(x)}
            style={{ position: 'absolute', top: 0, right: 0, backgroundColor: '#ffffffcc' }}
          >
            <Close fontSize="small" />
          </IconButton>
        </div>
      ))}
    </div>
  ) : null;

export { compressImage, MessageAttachments, DraftAttachments };
